<!-- Sticky Content -->
<div
	class="{{ pageHeaderStyleClassOverwrite }} position-relative mx-auto sticky-content maxWidth-limit"
	[ngClass]="{
		'isScrolled': isScrolled
	}"
>

	<!-- Page Header -->
	<app-page-header
		*ngIf="renderPageHeader"
		[pageHeaderWrapperStyleClassOverwrite]="pageHeaderWrapperStyleClassOverwrite"
		[showBackNav]="pageHeaderShowBackNav"
		[title]="pageHeaderTitle"
		(navigateBackEmitter)="pageHeaderNavigateBackEmitter.emit($event)"
	></app-page-header>

	<!-- Projected Sticky Content -->
	<ng-content select=".sticky-content"></ng-content>
</div>

<!-- Scrollable Content -->
<div
	class="scrollable-content {{ scrollableContentHeight }}"
	[ngClass]="scrollableContentContainerStyleNgClassMap"
	appDomTreeChanged
	appScrollEvent
	(domChangeEmitter)="onScrollableContentChange($event)"
	(scrollData)="onScroll($event)"
>
	<div
		class="{{ scrollableContentWrapperStyleClassOverwrite }} mt-3 mx-auto maxWidth-limit"
		[ngClass]="scrollableContentWrapperStyleNgClassMap"
	>
		<!-- Projected Scrollable Content -->
		<ng-content select=".scrollable-content"></ng-content>
	</div>
</div>
